/**
 * Step 2 In funnel
 * Select treatement wells
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {
  AppBar, Toolbar, Typography, Drawer, Box, Select, MenuItem, Stack,
  FormControl, TextField, InputLabel, Button, IconButton,
  Grid,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import PersonIcon from '@mui/icons-material/Person';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

import Map from '../../components/Map';
import Search from '../../components/Search';
import Header from '../../components/Header';

import useCartofactWells from '../../hooks/useCartofactWells';

const drawerWidth = 240;

const containerStyle = {
  width: '100vw',
  height: '100vh',
  position: 'relative'
};

const mapContainerStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 1
};

const TreatmentPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    filter,
    cartofactWells,
    selectedTreatmentWells,
    ...fzpState
  } = useSelector(state => state.fpzReducer);
  // order by distance from selected well if selectedTreamentWells.length > 0
  //const orderBy = selectedTreatmentWells?.length > 0 ? {
  //orderBy: 
  //} : null;
  useCartofactWells({ toggleCartofactWells: true, boundingBox: fzpState?.map?.boundingBox, filter });

  const [mapCenter, setMapCenter] = useState(null);
  const [mapZoom, setMapZoom] = useState(null);


  const defaultFpzRadius = 500;
  const defaultFpzRadiusColor = '#66FFFF';

  const handleChangeFpzRadius = (index, fpzRadius, well) => {
    console.log('handleChangeFpzRadius', index, fpzRadius, well);
    dispatch({ type: 'UPDATE_FPZ_RADIUS', payload: { index, fpzRadius, well } });
    dispatch({ type: 'SET_OFFSET_WELLS', payload: { well, offsetWells: [] } }); // clear offsets on fpz radius change
  };

  const handleAddFpzRadius = (well) => {
    dispatch({ type: 'ADD_FPZ_RADIUS', payload: well });
    dispatch({ type: 'SET_OFFSET_WELLS', payload: { well, offsetWells: [] } }); // clear offsets on fpz radius change
  }

  const handleDeleteFpzRadius = (index, well) => {
    dispatch({ type: 'DELETE_FPZ_RADIUS', payload: { index, well } });
    dispatch({ type: 'SET_OFFSET_WELLS', payload: { well, offsetWells: [] } }); // clear offsets on fpz radius change
  }

  const handleClickWell = (well) => {
    console.log('handleClickWell', well);
    setMapCenter({ lat: well.lat, lng: well.lng });
    setMapZoom(15);
  }

  const handleDeleteWell = (well) => {
    dispatch({ type: 'DELETE_TREATMENT_WELL', payload: well });
  }

  return (
    <Box>
      {/* Map */}
      <Box sx={mapContainerStyle}>
        <Box
          sx={{
            position: 'absolute',
            top: 100,
            right: 16,
            zIndex: 2, // Make sure it's above the map
            backgroundColor: 'transparent',
            borderRadius: 1,
            boxShadow: 2,
            p: 1,
          }}
        >

          <Box sx={{ display: 'flex', gap: 1 }}>
            <Search />
            <Button
              variant="contained"
              size="small"
              onClick={selectedTreatmentWells?.length > 0 ? () => navigate('/app/offsets') : null}
              disabled={selectedTreatmentWells?.length > 0 ? false : true}
              sx={{ whiteSpace: 'nowrap' }}
            >
              Offsets
            </Button>
          </Box>
        </Box>
        <Map
          mapContainerStyle={{ width: '100%', height: '100%' }}
          center={{ lat: 49.5, lng: -100 }}
          zoom={5}
          cartofactWells={cartofactWells}
          defaultFpzRadius={defaultFpzRadius}
          selectedTreatmentWells={selectedTreatmentWells}
          defaultFpzRadiusColor={defaultFpzRadiusColor}
          newCenter={mapCenter}
          newZoom={mapZoom}
        />
      </Box>


    </Box>
  );
};

export default TreatmentPage;
